import { isFile, postAndReturnId, patchData, deleteData, uploadImages, getNewObjects, getMissingObjects, deleteMissingObjects } from "../../utils/functions";

export const createOrUpdateItem = async ( formData, setFormData, error, setError, originalItemData ) => {
  let currentSourceCityId,
    currentSourceStateId,
    currentSourceAreaId,
    currentSourceTypeId,
    currentSourceId,
    currentLocationId,
    currentItemId,
    currentSalesChannelId,
    itemStatus = formData.statuses[formData.statuses.length - 1],
    itemStatusId,
    TagIdsArray,
    itemTagIds,
    featuredImageName,
    extraImageNames,
    featuredImageId;

  console.log("formData", formData);
  if (
    !formData.source ||
    !formData.source.type.type ||
    !formData.description ||
    !formData.minimum_return ||
    !formData.featured_image
  ) {
    const missingFields = [];
    if (!formData.source) missingFields.push('source');
    if (!formData.source.type.type) missingFields.push('source type');
    if (!formData.description) missingFields.push('description');
    if (!formData.minimum_return) missingFields.push('minimum return');
    if (!formData.featured_image) missingFields.push('featured image');

    setError(`The new item can't be created without the following data: ${missingFields.join(', ')}`);
  } else {
    if (error) {
      setError('');
    }
    try {
      // Source
      if (formData.source.area.city.city && formData.source.area.state.state) {
        currentSourceCityId = formData.source.area.city.id || (await postAndReturnId('source-city', { city: formData.source.area.city.city }));
        currentSourceStateId = formData.source.area.state.id || (await postAndReturnId('source-state', { state: formData.source.area.state.state }));
      }
  
      const [sourceCityId, sourceStateId] = await Promise.all([currentSourceCityId, currentSourceStateId]);
      console.log("sourceCityId", sourceCityId)
      console.log("sourceStateId", sourceStateId)

      if (sourceCityId && sourceStateId) {
        currentSourceAreaId = formData.source.area.id || (await postAndReturnId('source-area', { city_id: sourceCityId, state_id: sourceStateId }));
      }
      currentSourceTypeId = formData.source.type.id || (await postAndReturnId('source-type', { type: formData.source.type.type }));

      const [sourceAreaId, sourceTypeId] = await Promise.all([currentSourceAreaId, currentSourceTypeId]);
      console.log("sourceAreaId", sourceAreaId)
      console.log("sourceTypeId", sourceTypeId)

      const newSource = { name: formData.source.name, area_id: sourceAreaId, type_id: sourceTypeId };
      currentSourceId = formData.source.id || (await postAndReturnId('source', newSource));

      currentLocationId = formData.location.id || await postAndReturnId('location', { name: formData.location.name });

      // item
      const [sourceId, locationId] = await Promise.all([currentSourceId, currentLocationId]);
      console.log("sourceId", sourceId)
      console.log("locationId", locationId)

      if (originalItemData) {
        currentItemId = await patchData(`item/${originalItemData.id}`, {
          entry_date: formData.entry_date,
          source_id: sourceId,
          is_media_mail: formData.is_media_mail,
          estimated_shipping: formData.estimated_shipping || 0,
          minimum_return: formData.minimum_return,
          description: formData.description,
          location_id: locationId,
          shipping_cost: null,
          sale_price: null
        });
      } else {
        currentItemId = await postAndReturnId('item', {
          entry_date: formData.entry_date,
          source_id: sourceId,
          is_media_mail: formData.is_media_mail,
          estimated_shipping: formData.estimated_shipping || 0,
          minimum_return: formData.minimum_return,
          description: formData.description,
          location_id: locationId,
          shipping_cost: null,
          sale_price: null
        });
      }

      if (!originalItemData && itemStatus.sales_channel.id) {
        // sales channel
        currentSalesChannelId = itemStatus.sales_channel.id || await postAndReturnId('sales-channel', { channel: itemStatus.sales_channel.channel });
      }
        // item status
        const [itemId, salesChannelId] = await Promise.all([currentItemId, currentSalesChannelId]);
        console.log("itemId", itemId)
        console.log("salesChannelId", salesChannelId)

      if (!originalItemData) {
        itemStatusId = await postAndReturnId('item-status', {
          entry_date: itemStatus.entry_date,
          item_id: itemId,
          status_id: itemStatus.status.id,
          sales_channel_id: salesChannelId,
          review_date: itemStatus.review_date
        });
        console.log("itemStatusId", itemStatusId)
      }

      // tags and tag tag types
      // eslint-disable-next-line no-inner-declarations
      async function processTag(tag) {
        if (tag.id) {
          return tag.id;
        }
      
        try {
          // Create the tag and get its ID
          const tagId = await postAndReturnId('tag', { name: tag.name });
      
          // Validate and process tag types
          if (!Array.isArray(tag.tagTypes)) {
            throw new Error('tag.types must be an array of tag type arrays.');
          }
      
          const relationshipIds = await Promise.all(
            tag.tagTypes.map(async (type) => {
              // Create new tag type if needed
              const tagTypeId = type.id || await postAndReturnId('tag-type', { type: type.type })
          
              // Create relationship and return its ID
              return await postAndReturnId('tag-tag-type', { tag_id: tagId, tag_type_id: tagTypeId });
            })
          );
      
          return { tagId, relationshipIds };
        } catch (error) {
          console.error('Error processing tag:', error);
          throw error;
        }
      }

      // eslint-disable-next-line no-inner-declarations
      async function processTagArray(tagArray) {
        const promises = tagArray.map(processTag);
        const results = await Promise.all(promises);
        
        const tagIds = results.map(result => {
          if (typeof result === 'object' && 'tagId' in result) {
            return result.tagId;
          } else {
            return result;
          }
        });
        
        const tagTagTypeIds = results.reduce((acc, result) => {
          if (typeof result === 'object' && 'tagTagTypeIds' in result) {
            return acc.concat(result.tagTagTypeIds);
          } else {
            return acc;
          }
        }, []);
        
        const filteredTagIds = tagIds.filter(id => id !== null);
        const filteredTagTagTypeIds = tagTagTypeIds.filter(id => id !== null);
        
        return { tagIds: filteredTagIds, tagTagTypeIds: filteredTagTagTypeIds };
      }

      // item tags
      if (originalItemData) {
        TagIdsArray = await processTagArray(getNewObjects(originalItemData.tags, formData.tags))
        const removedTagIdArray = getMissingObjects(originalItemData.tags, formData.tags)
        console.log('removedTagIdArray', removedTagIdArray)
        deleteMissingObjects(removedTagIdArray)
      } else {
        TagIdsArray = await processTagArray(formData.tags);
      }
      console.log("currentTagArrayIds.tagIds", TagIdsArray.tagIds);
      console.log("currentTagArrayIds.tagTagTypeIds", TagIdsArray.tagTagTypeIds);

      const itemTagPromises = TagIdsArray.tagIds.map(async (tagId) => {
        let itemTagId;
        if (originalItemData) {
          itemTagId = await postAndReturnId('item-tag', { item_id: originalItemData.id, tag_id: tagId });
        } else {
          itemTagId = await postAndReturnId('item-tag', { item_id: itemId, tag_id: tagId });
        }
        return itemTagId;
      });

      itemTagIds = await Promise.all(itemTagPromises);

      console.log("Item Tag IDs:", itemTagIds);

      // image uploads
      const uploadImagesWithPrefix = async () => {
        const modifiedExtraImageNames = [];
      
        // Upload extra images
        await Promise.all(
          formData.extra_images.map(async (image, index) => {
            if (!isFile(image) && originalItemData.featured_image === image) {
              if (!isFile(formData.featured_image)) {
                await deleteData('extra-image', formData.featured_image.id);
              }
              await deleteData('featured-image', image.id);
              await postAndReturnId('extra-image', { item_id: originalItemData.id, image: image.image });
            } else if (isFile(image)) {
              const prefixedFileName = `${itemId}-${image.name}`;
              modifiedExtraImageNames.push(prefixedFileName);
      
              const formDataExtra = new FormData();
              formDataExtra.append(`extraImage${index}`, image, prefixedFileName);
      
              return await uploadImages(formDataExtra);
            }
          })
        );
      
        console.log("Modified extraImageNames", modifiedExtraImageNames);
      
        // Upload the featured image
        if (isFile(formData.featured_image)) {
          if (originalItemData) {
            featuredImageName = `${originalItemData.id}-${formData.featured_image.name}`;
          } else {
            featuredImageName = `${itemId}-${formData.featured_image.name}`;
          }
          const formDataFeatured = new FormData();
          formDataFeatured.append('featuredImage', formData.featured_image, featuredImageName);
        
          await uploadImages(formDataFeatured);
        }
      
        return modifiedExtraImageNames;
      };
      
      // featured image
      if (originalItemData) {
        if (isFile(formData.featured_image)) {
          featuredImageName = `${originalItemData.id}-${formData.featured_image.name}`;
          featuredImageId = await postAndReturnId('featured-image', { item_id: originalItemData.id, image: featuredImageName });
        } else if (formData.featured_image.image !== originalItemData.featured_image.image) {
          featuredImageName = formData.featured_image.image;
          featuredImageId = await postAndReturnId('featured-image', { item_id: originalItemData.id, image: featuredImageName });
        } else {
          featuredImageName = formData.featured_image.image;
          featuredImageId = formData.featured_image.id;
        }
      } else {
        featuredImageName = `${itemId}-${formData.featured_image.name}`;
        featuredImageId = await postAndReturnId('featured-image', { item_id: itemId, image: featuredImageName });
      }
      console.log("featuredImageId", featuredImageId);
      
      // extra images
      extraImageNames = await uploadImagesWithPrefix();
      console.log("Final extraImageNames", extraImageNames);
      // eslint-disable-next-line no-inner-declarations
      async function postExtraImage(itemId, imageName) {
        try {
          let extraImageId
          if (originalItemData) {
            extraImageId = await postAndReturnId('extra-image', { item_id: originalItemData.id, image: imageName });
          } else {
            extraImageId = await postAndReturnId('extra-image', { item_id: itemId, image: imageName });
          }
          console.log(`Posted extra image ${imageName} with ID ${extraImageId}`);
          return extraImageId;
        } catch (error) {
          console.error(`Error posting extra image ${imageName}:`, error);
          return null;
        }
      }
      
      for (const imageName of extraImageNames) {
        console.log('imageName', imageName)
        await postExtraImage(itemId, imageName);
      }

      if (!originalItemData) {
        setFormData((prevData) => ({
          ...prevData,
          description: '',
          estimated_shipping: '',
          extra_images: [],
          featured_image: null,
          is_media_mail: false,
          minimum_return: '',
          source: {
            ...prevData.source,
            id: sourceId,
            type: {
              ...prevData.source.type,
              id: sourceTypeId
            },
            area: {
              id: sourceAreaId,
              city: {
                ...prevData.source.area.city,
                id: sourceCityId
              },
              state: {
                ...prevData.source.area.state,
                id: sourceStateId
              },
            }
          },
          location: {
            ...prevData.location,
            id: locationId
          },
          tags: [],
          statuses: [
            {
              ...prevData.statuses[prevData.statuses.length - 1],
              sales_channel: {
                ...prevData.statuses[prevData.statuses.length - 1].sales_channel,
                id: salesChannelId || ''
              }
            }
          ],
        }))
      }
    } catch (err) {
      console.error(err);
      if (originalItemData) {
        setError('There was a problem updating the item.');
      } else {
        setError('There was a problem creating the new item.');
      }
    }
  }
};

export default createOrUpdateItem;
